<nz-card nzTitle="Control Specification" [nzExtra]="headerExtra">
  <ng-container *ngIf="error$ | async as errorMsg; else resultTpl">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>

  <ng-template #headerExtra>
    show all
    <nz-switch
      [ngModel]="false"
      (ngModelChange)="showAllSpecifications($event)"
      [nzLoading]="(controlSpecificationsLoading$ | async) ?? false"
    ></nz-switch>
  </ng-template>
</nz-card>

<ng-template #resultTpl>
  <nz-skeleton [nzActive]="true" [nzLoading]="(designLoading$ | async) ?? false">
    <nz-table
      #tsTable
      [nzScroll]="{ x: '800px' }"
      [nzData]="(pagination$ | async)?.data ?? []"
      [nzLoading]="(controlSpecificationsLoading$ | async) ?? false"
      nzSize="small"
      [nzPageSizeOptions]="[5, 10, 20, 30]"
      nzShowSizeChanger
      [(nzPageSize)]="perPage"
      [(nzPageIndex)]="pageIndex"
      (nzPageSizeChange)="perPageChange($event)"
      (nzPageIndexChange)="paginatorRef.setPage($event)"
      [nzTotal]="(pagination$ | async)?.total ?? 0"
    >
      <thead>
        <tr>
          <th></th>
          <th>Task List Group</th>
          <th>Group Counter</th>
          <th>Usage</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody class="em-no-table-row-hover">
        <ng-container *ngFor="let item of tsTable.data; trackBy: trackByRef">
          <tr>
            <td nzShowExpand (nzExpandChange)="expansionChange($event, item)"></td>
            <td>
              {{ item.taskListGroup }}
            </td>
            <td>{{ item.groupCounter }}</td>
            <td>{{ item.usage }}</td>
            <td>{{ item.description }}</td>
          </tr>
          <tr *ngIf="(controlSpecificationUiState$ | async)?.[item.id]?.isExpanded">
            <td colspan="5">
              <em-operations-table
                [loading]="(controlSpecificationUiState$ | async)?.[item.id]?.loading ?? false"
                [taskListHeader]="item"
              ></em-operations-table>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
